// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__VGvx5","h1":"SectionHero_h1__mwjr9","marketplaceColoredText":"SectionHero_marketplaceColoredText__Jeida","description":"SectionHero_description__rwmJz"};